import React from 'react';
import { withRouter } from 'react-router';
import Field from './Field';
import Icon from './icon.png';
import Title from '../../Symbols/Title';
import { Suggester, Theme } from './styles';

class Suggest extends React.PureComponent {
	onSelect = (event, { suggestion: { id } = {} }) => {
		this.props.history.push('/obec/'+ id);
	};

	render() {
		return <Suggester>
			<Title>
				<img src={Icon} />
				Vyhledejte si obec
			</Title>
			<Field rootUrl={this.props.rootUrl} onSelect={this.onSelect} theme={Theme} limit={9} />
		</Suggester>;
	}
}

export default withRouter(Suggest);
